export interface ActivityTimeSpentUnit {
  id: string;
  name: string;
  singular: string;
  plural: string;
}

export const ACTIVITY_TIME_SPENT_UNITS: ActivityTimeSpentUnit[] = [
  {
    id: "day",
    name: "Dagen",
    singular: "Dag",
    plural: "Dagen",
  },
  {
    id: "hour",
    name: "Uren",
    singular: "Uur",
    plural: "Uren",
  },
];
